// removed by extract-text-webpack-plugin
module.exports = {"panel":"_1_5KL","panel-header":"HHiAY","panel-header-light":"_1DPqd"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/panel.css
 ** module id = 84
 ** module chunks = 1
 **/